/**
A simple utility that wraps a value with an array
[Inspired by Array.wrap() in Ruby]

@example
```
arrayWrap([1, 2, 3]); // => [1, 2, 3]
arrayWrap(1); // => [1]
arrayWrap(null); // => []
arrayWrap(); // => []
```
*/
export const arrayWrap = <T>(value?: T[] | T | null): T[] => {
  return ([] as T[]).concat(value ?? []);
};
